import script from "./Modal.vue?vue&type=script&lang=ts&setup=true"
export * from "./Modal.vue?vue&type=script&lang=ts&setup=true"

import "./Modal.vue?vue&type=style&index=0&id=38cfbfbc&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-38cfbfbc"]])

export default __exports__